import { DemandeAffiliationStatutBackOfficeEnum } from '@graphql/generated';
import { DemandeAffiliationStatutBackOffice } from '@lib/models/demande-affiliation/types/demande-statut.type';

export class StatutBackOfficeMapper {
  public static toGraphQl(
    input: DemandeAffiliationStatutBackOffice | null
  ): DemandeAffiliationStatutBackOfficeEnum | undefined {
    const mapping: Record<
      DemandeAffiliationStatutBackOffice,
      DemandeAffiliationStatutBackOfficeEnum
    > = {
      a_affecter: DemandeAffiliationStatutBackOfficeEnum.AAffecter,
      a_controler: DemandeAffiliationStatutBackOfficeEnum.AControler,
      controle_en_cours: DemandeAffiliationStatutBackOfficeEnum.ControleEnCours,
      nc_traitee: DemandeAffiliationStatutBackOfficeEnum.NcTraitee,
      relance: DemandeAffiliationStatutBackOfficeEnum.Relance,
      affilie: DemandeAffiliationStatutBackOfficeEnum.Affilie,
      annule: DemandeAffiliationStatutBackOfficeEnum.Annule,
      en_signature: DemandeAffiliationStatutBackOfficeEnum.EnSignature,
      expire: DemandeAffiliationStatutBackOfficeEnum.Expire,
      nc_a_traiter: DemandeAffiliationStatutBackOfficeEnum.NcATraiter,
      refuse: DemandeAffiliationStatutBackOfficeEnum.Refuse,
      affiliation_en_cours: DemandeAffiliationStatutBackOfficeEnum.AffiliationEnCours,
    };
    return input ? mapping[input] : undefined;
  }

  public static fromGraphQl(
    input: DemandeAffiliationStatutBackOfficeEnum | null | undefined
  ): DemandeAffiliationStatutBackOffice | undefined {
    const mapping: Record<
      DemandeAffiliationStatutBackOfficeEnum,
      DemandeAffiliationStatutBackOffice
    > = {
      A_AFFECTER: 'a_affecter',
      A_CONTROLER: 'a_controler',
      CONTROLE_EN_COURS: 'controle_en_cours',
      NC_TRAITEE: 'nc_traitee',
      RELANCE: 'relance',
      AFFILIE: 'affilie',
      ANNULE: 'annule',
      EN_SIGNATURE: 'en_signature',
      EXPIRE: 'expire',
      NC_A_TRAITER: 'nc_a_traiter',
      REFUSE: 'refuse',
      AFFILIATION_EN_COURS: 'affiliation_en_cours',
    };
    return input ? mapping[input] : undefined;
  }
}
